

export const dwhReportManagementColumns = [
  {
    title: 'תאריך ביצוע הפעולה' ,
    key: 'createdDate',
    sortKey: 'created_date',
    width: '130px',
    sortable: true,
    mobileMode:{
      title: 'ת. ביצוע הפעולה',
      width: '75px',
    }
  },
  {
    title: 'מספר מנוי',
    key: '_subscriber',
    sortKey: 'subscriber',
    width: '130px',
    sortable: true,
    fromJson: true,
    mobileMode:{
      title: "מס' מנוי",
      width: '90px',
    }
    
  },
  {
    title: 'סוג פעולה',
    key: 'he_actionType',
    sortKey: 'action_he_name',
    sortable: true,
    width: '190px',
    mobileMode:{
      title: 'סוג פעולה',
      width: '105px',
    }
  },
  {
    title: 'פירוט פעולה',
    key: 'he_message',
    width: '150px',

  },
  {
    title: 'שם מלא של איש קשר',
    sortable: true,
    sortKey: 'customer_name',
    key: 'customerName',
    width: '160px',
  },
  {
    title: 'מספר ארגון',
    key: '_orgId',
    width: '120px',
    fromJson: true,
  },
  {
    title: 'מספר ח.פ.',
    key: '_companyNumber',
    width: '130px',
    fromJson: true,
  }
  ,
  {
    title: 'פרטים נוספים', 
    key: 'businessDetails',
    width: '160px',
    defaultValue: 'פרטים נוספים',
    type: 'openNewRow',
    getExpndedData: (item , mobileMode = false) => {
      if(mobileMode){
        return getMobileModeExpandedData(item);
      }
      if(item.businessDetails){
       var allkeyIsRegular =  Object.keys(JSON.parse(item.businessDetails)).every(key => key.startsWith('_'));
        if(allkeyIsRegular){
          return null;
        }
        return item.businessDetails;
      }
    },
    className: 'expandable-cell',
    mobileMode:{
      title: 'פירוט',
      width: '55px',
    }
  }
  // {
  //   title: 'מספר חברה',
  //   key: 'companyId',
  // }
//   {
//     title: 'פרטים נוספים',
//     key: 'additionalDetails',
//   },
];


const getMobileModeExpandedData = (item) => {
  var expandedData = {};
  dwhReportManagementColumns.forEach(column => {
    if(!column.mobileMode){
      expandedData[column.title] =item[column.key];
    }
  });
  expandedData = {...expandedData , ...JSON.parse(item.businessDetails) };
  return JSON.stringify(expandedData);
}


export const Mesages ={

  NoResultsFound: {
    icon:  require('./icon/search.svg'),
    title: 'ברוכים הבאים למערכת ניהול פעולות בשירות עצמי',
    description: 'עדיין לא נרשמו פעולות במערכת לאחר ביצוע הפעולה הראשונה, \n היא תוצג כאן באופן אוטומטי',
  },
  NoResultsFoundForFilter: {
    icon: require('./icon/error.svg') ,
    title: 'לא נמצאו תוצאות שתואמות את החיפוש',
  }

}